export const Compliances = ["KVKK", "DDO", "BSY", "SPK", "MASAK", "EPDK"];
export const ScopedProducts = [...Compliances];
